import React from 'react';
import { LogoSlimText } from 'design-comuni-plone-theme/components/ItaliaTheme';
import { LogoSlimHome } from 'design-comuni-plone-theme/components/ItaliaTheme';
import { useIntl } from 'react-intl';
const HeaderSlimBrandUniba = ({
    className,
    href,
    ...attributes
}) => {
    const intl = useIntl();
    const intl_tornaUnibaAlt = intl.formatMessage({ id: 'tornaUnibaAlt' });
    const intl_unibaCN = intl.formatMessage({ id: 'UnibaCN' });
    return (
        <header className={className}>
            {/* <div> */}
            <a
                href={href}
                {...attributes}
                aria-label={intl_tornaUnibaAlt}
                title={intl_tornaUnibaAlt}
            >
                <LogoSlimHome alt="Logo UniBA" aria-hidden="true" focusable="false" />
                &nbsp;
                <LogoSlimText alt={intl_unibaCN} />
            </a>
            {/* </div> */}
        </header>
    );
};

export default HeaderSlimBrandUniba;